<template>
    <b-row class="ft-vehicle-detail-container">
        <b-col cols="12">
            <div class="ft-vehicle-detail">
                <span>
                    <icon-base icon-name="truck" width="22" height="22" viewbox="0 0 20 20">
                        <icon-truck/>
                    </icon-base>
                </span>
                <div class="ft-vehicle-label small-text text-grey-2">
                    <h6>{{truckType}}</h6>
                    <!-- <span>40 ft mxl HQ</span> -->
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import IconBase from '../IconBase.vue'
import IconTruck from '../icons/IconTruck.vue'

export default {
    name: 'VehicleDetail',
    components: {
        IconBase,
        IconTruck,
    },
    props: {
        truckType: [String]
    }
}
</script>

<style lang="scss">
.ft-vehicle-detail {
    display: flex;
}
    .ft-vehicle-label {
        margin-left: 1rem;

        h6 {
            font-weight: normal;
            font-size: 14px;
            line-height: 20px;
            color: #474747;
            margin-bottom: 0;
        }

        span {
            font-weight: normal;
            font-size: 14px;
            line-height: 20px;
            color: #707070;
        }
    }
</style>